var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgXexchange(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 48,
    height: 48,
    rx: 8,
    fill: "#3A66EE"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2784 24.0018L8 16.5233L10.4005 12L23.4748 17.1844C23.8116 17.3181 24.1848 17.3181 24.5214 17.1844L37.5995 12L40 16.5233L25.7216 24.0018L40 31.4767L37.5995 36L24.5251 30.8156C24.1884 30.682 23.8152 30.682 23.4786 30.8156L10.404 36L8.00367 31.4767L22.282 23.9982L22.2784 24.0018Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgXexchange);
export default __webpack_public_path__ + "static/media/xexchange.8b7903966b84b9519c93bb8b6b9e6edf.svg";
export { ForwardRef as ReactComponent };